import {
  CHAT_ADD_MESSAGE,
  CHAT_ATTACHMENT_UPLOADING,
  CHAT_HIDE_QUICK_QUESTIONS,
  CHAT_NEW,
  CHAT_PANE_CLOSE,
  CHAT_PANE_OPEN,
  CHAT_SET_LOADING,
  CHAT_SET_MESSAGES,
  CHAT_SHOW_QUICK_QUESTIONS,
  CHAT_STREAM_DONE,
  CHAT_STREAM_START,
  CHAT_STREAM_TOKEN,
  CHATBOT_ACCESS_SET,
  HISTORY_VIEW_CLOSE,
  HISTORY_VIEW_OPEN,
  MY_TICKETS_LOADING,
  MY_TICKETS_SET,
  QUICK_QUESTIONS_SET,
  SESSIONS_SET,
  TICKET_SELECT,
  TICKET_SUBMITTED,
  TICKETS_PANEL_CLOSE,
  TICKETS_PANEL_OPEN,
  TOKEN_USAGE_SET,
} from "../actions/chatbot";

const initialState = {
  // Chat pane
  chatPaneOpen: false,
  historyViewActive: false,
  currentSessionId: null,
  sessions: [],
  messages: [],
  quickQuestions: [],
  showQuickQuestions: true,
  chatLoading: false,
  chatAttachmentUploading: false,
  ticketSubmitted: null,

  // Access (icon visibility + trial/expired gating) -- null until /chatbot/access/ resolves
  access: { allowed: null, reason: null, message: null },

  // Token usage
  totalInputTokens: 0,
  totalOutputTokens: 0,

  // Tickets panel
  ticketsPanelOpen: false,
  myTickets: [],
  myTicketsLoading: false,
  selectedTicketId: null,
};

export function chatbot(state = initialState, action) {
  switch (action.type) {
    case CHAT_PANE_OPEN:
      return { ...state, chatPaneOpen: true };

    case CHAT_PANE_CLOSE:
      return { ...state, chatPaneOpen: false, historyViewActive: false };

    case HISTORY_VIEW_OPEN:
      return { ...state, historyViewActive: true };

    case HISTORY_VIEW_CLOSE:
      return { ...state, historyViewActive: false };

    case CHAT_NEW:
      return {
        ...state,
        currentSessionId: action.payload,
        messages: [],
        showQuickQuestions: true,
        historyViewActive: false,
        ticketSubmitted: null,
      };

    case CHAT_ADD_MESSAGE:
      return { ...state, messages: [...state.messages, action.payload] };

    case CHAT_SET_MESSAGES:
      return { ...state, messages: action.payload, showQuickQuestions: false };

    case CHAT_SET_LOADING:
      return { ...state, chatLoading: action.payload };

    case CHAT_ATTACHMENT_UPLOADING:
      return { ...state, chatAttachmentUploading: action.payload };

    case CHAT_STREAM_START:
      return {
        ...state,
        chatLoading: true,
        messages: [
          ...state.messages,
          { role: "assistant", content: "", streaming: true, created_on: new Date().toISOString() },
        ],
      };

    case CHAT_STREAM_TOKEN: {
      const msgs = [...state.messages];
      const last = msgs[msgs.length - 1];
      if (last && last.streaming) {
        msgs[msgs.length - 1] = { ...last, content: last.content + action.payload };
      }
      return { ...state, messages: msgs };
    }

    case CHAT_STREAM_DONE: {
      const msgs = [...state.messages];
      const last = msgs[msgs.length - 1];
      const { action: act, ticket_id, error, message: displayMsg, message_id } = action.payload;
      if (last && last.streaming) {
        msgs[msgs.length - 1] = {
          ...last,
          id:        message_id || null,
          streaming: false,
          action:    act || null,
          ticket_id: ticket_id || null,
          is_action: !!act,
          content: error
            ? "I'm having trouble connecting right now. Please try again in a moment."
            : (act && displayMsg ? displayMsg : last.content),
        };
      }
      return { ...state, chatLoading: false, messages: msgs };
    }

    case CHAT_HIDE_QUICK_QUESTIONS:
      return { ...state, showQuickQuestions: false };

    case CHAT_SHOW_QUICK_QUESTIONS:
      return { ...state, showQuickQuestions: true };

    case QUICK_QUESTIONS_SET:
      return { ...state, quickQuestions: action.payload };

    case SESSIONS_SET:
      return { ...state, sessions: action.payload };

    case TICKET_SUBMITTED:
      return { ...state, ticketSubmitted: action.payload };

    case TICKETS_PANEL_OPEN:
      return { ...state, ticketsPanelOpen: true };

    case TICKETS_PANEL_CLOSE:
      return { ...state, ticketsPanelOpen: false, selectedTicketId: null };

    case MY_TICKETS_LOADING:
      return { ...state, myTicketsLoading: true };

    case MY_TICKETS_SET:
      return { ...state, myTickets: action.payload, myTicketsLoading: false };

    case TICKET_SELECT:
      return {
        ...state,
        selectedTicketId: state.selectedTicketId === action.payload ? null : action.payload,
      };

    case TOKEN_USAGE_SET:
      return {
        ...state,
        totalInputTokens:  action.payload.total_input_tokens  || 0,
        totalOutputTokens: action.payload.total_output_tokens || 0,
      };

    case CHATBOT_ACCESS_SET:
      return { ...state, access: action.payload };

    default:
      return state;
  }
}
